import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'

import IFrame from '../../app/modules/IFrame'
import {extension,forceDownload,isValidUrl} from '../../requests/api'

import Box from '@material-ui/core/Box'
import Chip from '@material-ui/core/Chip'
import Button from '@material-ui/core/Button'
import GetAppIcon from '@material-ui/icons/GetApp'
import LoaderSingleComponent from '../../loader-app/modules/LoaderSingleComponent'
import Page401 from '../../theme-structure/modules/404'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
    viewerIFrame: {
        borderRadius: theme.shape.borderRadius
    }
}))

const FileDownloadBtn = (props) => {
    
    const {save_as,file_url,loading,...rest} = props

    if (!file_url && loading)
        return <LoaderSingleComponent layout="circular" />

    if(!file_url && !loading)
        return null

    return (
        <Button 
            {...rest}
            onClick={() => forceDownload(file_url, save_as)}
            startIcon={<GetAppIcon />}
        >
            {props.children}
        </Button>
    )
}

const EMPTY_FUNC = () => null

const FileViewer = ({
    output = "viewer",
    filename = "",
    mime_type = "",
    save_as = "",
    url = "",
    fetchFile_f = EMPTY_FUNC,
    printDownloadBtn = true,
    ifNotMsg = "File preview is not available for the current file type",
    textDownloadBtn = "download",
    iframeToolbar = false
}) => {
    const classes = useStyles()

    const [loading, setLoading] = useState(false)
    const [file_url, setFileUrl] = useState(url)

    const validTypes = ['pdf', 'text/', 'json', 'image', 'video', 'audio'];
    const iframe = validTypes.some(type => mime_type.includes(type));

    const fetchFile = async() => {
        setLoading(true)

        const data = url ? url: await fetchFile_f()

        setFileUrl(data)
        setLoading(false)
    }

    useEffect(() => {
        fetchFile()
    }, [])

    const outputMap = {
        "button": (
            <FileDownloadBtn
                color="primary"
                variant="contained"
                save_as={save_as}
                file_url={file_url}
                loading={loading}
            >
                {textDownloadBtn}
            </FileDownloadBtn>
        ),
        "viewer": (
            <>
                {iframe
                    ? <>
                        {loading
                            ? <LoaderSingleComponent width="100%" />
                            : <IFrame id={"viewer-"+filename}
                                src={file_url+(!iframeToolbar ? '#toolbar=0&navpanes=0' : '')}
                                className={classes.viewerIFrame}
                                style={{
                                    width:"100%",
                                    height:"100%",
                                    border: "1px solid lightgrey",
                                    borderRadius:"10px",
                                }}
                                ifErrorComp={<Page401 />}
                            />}
                    </>
                    : <>
                        <Box>
                            <Chip label={ifNotMsg} />
                        </Box>
                        {printDownloadBtn && (
                            <Box mt={2}>
                                <FileDownloadBtn color="primary" variant="contained"
                                    save_as={save_as}
                                    file_url={file_url}
                                    loading={loading}
                                >
                                    {textDownloadBtn}
                                </FileDownloadBtn>
                            </Box>
                        )}
                    </>
                }
            </>
        )
    }

    return outputMap?.[output]
}

export default FileViewer